module.exports = __webpack_public_path__ + "static/media/methodologies.c3bee0d8.svg";